import { I18n } from '@calendly/i18n';
import { Loader } from '@calendly/ui/components/loader';
import { SwitchInput } from '@calendly/ui/components/switch-input';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useGetAvailabilityUserHolidaySetV4Query, useUpdateAvailabilityUserHolidaySetV4Mutation } from '../api';
import { CountryCodeField } from './country_code_field';
import { sortHolidays } from './helpers';
import { HolidayList } from './holiday_list';
const holidaysContainerCss = "h148dlrv";
const HolidaysContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(holidaysContainerCss, props.className)} />;
});
const holidaysHeaderCss = "htntj4a";
const HolidaysHeader = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(holidaysHeaderCss, props.className)} />;
});
const switchLabelCss = "s7tf4rx";
const SwitchLabel = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'label';
  return <Component ref={ref} {...restProps} className={classNames(switchLabelCss, props.className)} />;
});
export const HolidaySettings = () => {
  const [updateHolidaySet] = useUpdateAvailabilityUserHolidaySetV4Mutation();
  const {
    isLoading,
    isFetching,
    isSuccess,
    data
  } = useGetAvailabilityUserHolidaySetV4Query();
  if (isLoading || isFetching) return <Loader size="small" />;
  if (!isSuccess) return null;
  const holidays = isSuccess ? sortHolidays(data.holidays) : [];
  const countryCode = holidays[0]?.key?.split('.')[0] || 'other';
  const uuid = data?.uri?.split('/')?.pop();
  const globalEnabled = holidays.some(({
    enabled
  }) => enabled);
  const onChangeGlobal = () => updateHolidaySet({
    uuid,
    holidays: holidays.map(holiday => ({
      ...holiday,
      enabled: !globalEnabled
    })),
    redirect: false
  });
  return <HolidaysContainer>
      <HolidaysHeader>
        <CountryCodeField uuid={uuid} countryCode={countryCode} />
        <SwitchLabel>
          <SwitchInput aria-label={I18n.t('publisher.account_settings.holidays.bulk_actions.toggle')} checked={globalEnabled} disabled={holidays.length === 0} onChange={onChangeGlobal} />
        </SwitchLabel>
      </HolidaysHeader>
      <HolidayList uuid={uuid} holidays={holidays} countryCode={countryCode} />
    </HolidaysContainer>;
};

require("./holiday_settings.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./holiday_settings.js");